if (window.innerWidth > 749) { 
  var Index_media_product_slider = new Swiper(".Index_media_product_slider", {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      sapceBetween: 96,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
  });
}


function updateActiveMedia() {
if (window.innerWidth < 750) return;
  const activeSlide = Index_media_product_slider.slides[Index_media_product_slider.activeIndex];
  if (!activeSlide) return;
  const dataSlide = activeSlide.dataset.slide;
  document.querySelectorAll('.Index_media_product_slider_media').forEach(media => {
    media.classList.toggle(
      'active',
      media.dataset.media === dataSlide
    );
  });
}
updateActiveMedia();
Index_media_product_slider.on('slideChange', updateActiveMedia);